import $ from 'jquery';

$(document).ready(function () {
  acfVcardBlock();
});

function acfVcardBlock() {
  $('.js-acf-vcard').each(function () {});
}
